/**
 * Path prefixes that do not require authentication. Users hitting these paths
 * should not be redirected to login (e.g. magic-link delivery confirm/reject).
 */
export const UNAUTHENTICATED_PATH_PREFIXES = [
  '/magic/deliveries/confirm',
  '/magic/deliveries/reject',
] as const;

export function isUnauthenticatedPath(pathname: string): boolean {
  return UNAUTHENTICATED_PATH_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix)
  );
}
